<!-- A public share is the spreadsheet only (Wook, 2026-10-03): its title and the text view, no metadata. -->
<div class="form" *appSheetsAppContext>
  <h2 class="form-title">
    <app-icon class="form-heading-title-icon" name="sapphire-sheets" />
    {{ sheet?.title }}
  </h2>

  <app-shared-signup-cta />

  <app-editor [data]="sheet?.body" [readOnly]="true" stchHighlightText />
</div>
